import instance from "./AxiosConfig";

const ChatApi = {
  processText: async (message, conversationId = null) => {
    try {
      const response = await instance.post("/api/workpermit/AiChat/ChatRequest", {
        message,
        conversationId,
      });
      
      const data = response.data || {};
      
      return {
        responseText: data.message || data.responseText || "",
        conversationId: data.conversationId || null,
        status: response.status,
      };
    } catch (e) {
      if (!e.response) {
        throw new Error("No se pudo conectar con el servidor");
      }
      
      return {
        status: e.response?.status || 500,
        data: e.response?.data || {},
      };
    }
  },

  getUserMessages: async (userId) => {
    try {
      const response = await instance.get(`/api/chat/messages/${userId}`);
      return response.data;
    } catch (e) {
      if (!e.response) {
        throw new Error("No se pudo conectar con el servidor");
      }
      throw new Error(`Error ${e.response.status}: ${e.response.statusText}`);
    }
  },
};

export default ChatApi;
